import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { Vieweligibility271Component } from './vieweligibility271.component';
const routes: Routes = [ { path: '', component: Vieweligibility271Component }];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class Vieweligibility271RoutingModule { }
